/**
 * <s-nav-tabs> — two-column mobile menu: category buttons on the left switch the
 * sub-category panel on the right.
 *
 * Markup:
 * - [data-nav-tab][aria-controls]  category buttons; aria-expanded marks the open one
 * - [data-nav-panel][id]           panels; only the open one is visible (hidden attribute)
 */
class SNavTabs extends HTMLElement {
  #ac;

  connectedCallback() {
    this.#ac = new AbortController();
    this.addEventListener(
      'click',
      (event) => {
        const tab = event.target.closest('[data-nav-tab]');
        if (!tab || !this.contains(tab)) return;
        this.open(tab);
      },
      { signal: this.#ac.signal },
    );
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }

  /** @param {HTMLElement} tab */
  open(tab) {
    const target = tab.getAttribute('aria-controls');
    for (const t of this.querySelectorAll('[data-nav-tab]')) {
      t.setAttribute('aria-expanded', String(t === tab));
    }
    for (const panel of this.querySelectorAll('[data-nav-panel]')) {
      panel.hidden = panel.id !== target;
      if (!panel.hidden) panel.scrollTop = 0;
    }
  }
}

if (!customElements.get('s-nav-tabs')) customElements.define('s-nav-tabs', SNavTabs);
